export enum CreditCardTypeEnum {
  visa ='visa',
  mc = 'mc',
  amex = 'amex',
  discover = 'discover',
  check = 'check',
  echeck = 'echeck',
}
